module.exports = __webpack_public_path__ + "img/violet_087.08387c4e.png";